
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/details",
      function () {
        return require("private-next-pages/details/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/details"])
      });
    }
  